import { OTA_CoveragePref } from "./ota_coveragepref.model";
import { OTA_OffLocService } from "./ota_offlocservice.model";

export class OTA_VehAvailRQInfo {
    public coveragePrefs = new Array<OTA_CoveragePref>();
    public offLocServices = new Array<OTA_OffLocService>();
}
